<template>
	<div id="app">
		<router-view />
	</div>
</template>

<script>
	export default {
		name: 'App',
	}
</script>

<script setup>
import { onMounted } from 'vue';

	onMounted(async () => {
    try {
      const scriptUrl = import.meta.env.VITE_URL_BASE_HEADER_FOOTER;
      const script = await import(/* @vite-ignore */ scriptUrl);
      const { instalarHeaderFooter } = script;

      instalarHeaderFooter({
			usuario: {},
			suporte:{
				telefone: '(11) 5555-9372',
				email: 'suporte.cliente@registrocivil.org.br'
			},
			escondeAcessoRemoto:true,
			escondeSuporteWhatsApp:true,
			escondePerguntasFrequentes:false,
			escondeFalePeloChat:true,
			// urlLogin: 'url-de-login',
			// urlLogout: 'url-de-logout',
			// urlRedirecionamentoSPRC: 'url-de-redirecionamento-sprc',
			// urlLoginICP: 'url-de-login-com-icp',
			// token: 'token que fará a comunicação com o IdRC',
			// expiresInMinutes: '720'
		});
    } catch (error) {
        console.error('Erro ao carregar o script de header e footer:', error);
    }
});
</script>

<style>
	#subHeader{
		display:none;
		visibility: hidden;
	}
</style>
